
    <div class="form-grid">
<div class="form-group">
        <label for="tipo-filtro">Estado</label>
       <!--  <select id="cbocircuito" class="form-control" [(ngModel)]="IdCircuitoSel"
            (change)="onChangeCircuitRegion($event)">
            <option [value]="0">Seleccione una opción</option>
            @for (itmData of lstFiltersEdos.data; track itmData.Id) {
            <option [value]="itmData.Id">
                <span [title]="itmData.Descripcion">{{itmData.Descripcion}}</span>
            </option>
            }
        </select> -->
         <ng-select placeholder="Seleccione una opción" id="cbocircuito"  [(ngModel)]="IdCircuitoSel" class="auto-grow"
            (change)="onChangeCircuitRegion($event)">
            @for (itmData of lstFiltersEdos.data; track itmData.Id) {
            <ng-option [value]="itmData.Id">
                <span [title]="itmData.Descripcion">{{itmData.Descripcion}}</span>
            </ng-option>
            }
        </ng-select>
    </div>
    <div class="form-group">
        <label for="tipo-organo">OCC</label>
       <!--  <select id="cboocc" class="form-control" [(ngModel)]="IdOrganoSel" (change)="onChangeOrganism($event)">
            <option [value]="0">Seleccione una opción</option>
            @for (itmData of lstFiltersOCC.data; track itmData.Id) {
            <option [value]="itmData.Id">
                <span [title]="itmData.Descripcion">{{itmData.Descripcion}}</span>
            </option>
            }
        </select> -->
         <ng-select id="cboocc" placeholder="Seleccione una opción" [(ngModel)]="IdOrganoSel" (change)="onChangeOrganism($event)" class="auto-grow">
            @for (itmData of lstFiltersOCC.data; track itmData.Id) {
            <ng-option [value]="itmData.Id">
                <span [title]="itmData.Descripcion">{{itmData.Descripcion}}</span>
            </ng-option>
            }
        </ng-select>
    </div>

    </div>
   